export const GET_TESTIMONIALS = "GET_TESTIMONIALS";
export const LOADER_FOR_TESTIMONIALS = "LOADER_FOR_TESTIMONIALS";
export const GET_OFFERMESSAGE = "GET_OFFERMESSAGE";
export const GET_PACKAGE_MATRIX = "GET_PACKAGE_MATRIX";

export interface ITestimonialsState {
    testimonials?: Testimonials[];
    isLoadingTestimonials: boolean;
    promoBannerText: string;
    packageMatrix: any;
}

export interface Testimonials {
    reviewStars: number;
    reviewHeader: string;
    reviewText: string;
    reviewerName: string;
    reviewPublishDate: string;
}

export interface getTestimonialAction {
    type: "GET_TESTIMONIALS";
    testimonials: Testimonials[];
}
export interface changeTestimonialLoaderAction {
    type: "LOADER_FOR_TESTIMONIALS";
    isLoadingTestimonials: boolean;
}
export interface promoBannerAction {
    type: "GET_OFFERMESSAGE";
    promoBannerText: string;
}
export interface packageMatrixAction {
    type: "GET_PACKAGE_MATRIX";
    packageMatrix: any;
}
export type KnownAction = getTestimonialAction | changeTestimonialLoaderAction | promoBannerAction | packageMatrixAction;
